import axios from '../components/shared/axios';
import moment from 'moment';

const baseURL = process.env.REACT_APP_BACKEND_URL;
const dateFormat = 'dddd, Do MMMM YYYY h:mm:ssA Z';

export const addCourseOffer = async (params) => {
  return await axios.post(`${baseURL}/course-offer`, params);
};

export const getCourseOfferById = async (id) => {
  return await axios.get(`${baseURL}/course-offer/${id}`);
};

export const getCourseOffers = async (pageNo, pageSize, param) => {
  let params = {};
  if (param) params = { pageNo, pageSize, ...param };
  else params = { pageNo, pageSize };
  return await axios.get(`${baseURL}/course-offers`, { params });
};

export const updateCourseOffer = async (id, params) => {
  return await axios.put(`${baseURL}/course-offer/${id}`, params);
};

export const getInitialValuesFromExistingCourseOffer = (
  courseOffer,
  operation
) => {
  let liveSessions = {};
  if (courseOffer) {
    courseOffer.liveSessions.forEach((liveSession) => {
      const key =
        liveSession.type === 'custom-live-session'
          ? `${liveSession.sectionNumber}-${liveSession.position}`
          : liveSession.type;

      if (liveSession.sessions) {
        liveSession.sessions = liveSession.sessions.map((session) => {
          return {
            ...session,
            startTime: !!session.startTime
              ? moment(new Date(session.startTime), dateFormat)
              : '',
            endTime: !!session.endTime
              ? moment(new Date(session.endTime), dateFormat)
              : ''
          };
        });
      }

      liveSessions[key] = {
        ...liveSession,
        image: liveSession.cardImgData.desktopImgData.src,

        //legacy
        startTime: !!liveSession.startTime
          ? moment(new Date(liveSession.startTime), dateFormat)
          : '',
        endTime: !!liveSession.endTime
          ? moment(new Date(liveSession.endTime), dateFormat)
          : ''
      };
    });

    // fix for trainers key as it is different in edit vs clone case
    let courseOfferTrainers = courseOffer?.trainers;
    if (operation?.toLowerCase() === 'edit') {
      courseOfferTrainers = courseOfferTrainers.map((trainer) => {
        return trainer.trainerId;
      });
    }

    return {
      courseCode: courseOffer.courseCode ?? '',
      courseId: courseOffer.courseId ?? '',
      description: courseOffer.description ?? '',
      code: courseOffer.code ?? '',
      courseOfferStatus: courseOffer.courseOfferStatus ?? '',
      startDate: !!courseOffer.startDate
        ? moment(courseOffer.startDate, dateFormat)
        : '',
      endDate: !!courseOffer.endDate
        ? moment(courseOffer.endDate, dateFormat)
        : '',
      frequency:
        courseOffer?.frequency?.map((freq) => {
          return freq;
        }) ?? [],
      minRegistrations: courseOffer.minRegistrations ?? 0,
      maxRegistrations: courseOffer.maxRegistrations ?? 0,
      trainers: courseOfferTrainers ?? [],
      location: courseOffer.location ?? '',
      whereToGo: courseOffer.whereToGo ?? '',
      calendarLink: courseOffer.calendarLink ?? '',
      whatToBring: courseOffer.whatToBring ?? '',
      classMaterialsLink: courseOffer.classMaterialsLink ?? '',
      courseFees: courseOffer.courseFees ?? 0,
      deposit: courseOffer.deposit ?? 0,
      generalNotes: courseOffer.generalNotes ?? '',
      pricingOptions: courseOffer.pricingOptions?._id,
      isSpecial: courseOffer.isSpecial,
      showPrice: courseOffer.showPrice,
      specialMessage: courseOffer.specialMessage,
      wave: courseOffer.wave,
      isPrePurchase: courseOffer.isPrePurchase,
      setReleaseDate: !!courseOffer.releaseDate,
      groupNumber: courseOffer.groupNumber,
      whatsappGroupLinks: courseOffer.whatsappGroupLinks,
      discordGroupLink: courseOffer.discordGroupLink,
      communityPlatforms: courseOffer.communityPlatforms,
      liveRegion: courseOffer.liveSessions[0]?.timezone ?? '',
      liveSessions
    };
  }
};
